'use strict';
require('../home.css');
require('../en.css');
require('../less/picker.less');
var globalTel = require('./globalTel.js');
require('./sensorsdata.js')
window.language = 'USA';
if (window.location.search.indexOf('locale=EN') > -1) {
  language = 'USA';
  $('.cmta').show()
} else if (window.location.search.indexOf('locale=JP') > -1) {
  language = 'JP';
  $('.cmta').hide()
} else if (window.location.search.indexOf('locale=KO') > -1) {
  language = 'KO';
  $('.cmta').hide()
} else if (window.location.search.indexOf('locale=TH') > -1) {
  language = 'TH';
  $('.cmta').hide()
} else if (window.location.search.indexOf('locale=zh-CN') > -1) {
  language = 'zh-CN';
  $('.cmta').show()
}
if(window.location.href.indexOf('joinTg') > -1){
  language = 'zh-CN';
  $('.cmta').show()
}
$('body').addClass(language);

$(function () {
  //等待加载完语言将body展示
  $('body').show();

  $('.go_href li a').click(function () {
    if ($(this).data('href')) {
      var lanCur = language;
      if (language == 'USA') {
        lanCur = 'EN';
      }
      window.location.href = $(this).data('href') + '?locale=' + lanCur;
    }
  });
  $('.navbar-header').click(function () {
    var collapse = $('.navbar-collapse');
    if (collapse.is(':visible')) {
      $('.navbar-header a').removeClass('close');
      collapse.hide();
    } else {
      $('.navbar-header a').addClass('close');
      collapse.show();
    }
  });

  //选择语言
  var defaultIndex = 0;
  var lanArr = [
    { value: 'English', abbr: 'EN' },
    { value: '日本語', abbr: 'JP' },
    { value: '한국어', abbr: 'KO' },
    { value: 'ภาษาไทย', abbr: 'TH' },
    { value: '简体中文', abbr: 'zh-CN' }];
  
  var locationPathname = window.location.pathname
   if(locationPathname == '/tanchen.html'){
      if (language == 'USA' || language == 'zh-CN') {
        lanArr = [
          { value: 'English', abbr: 'EN' },
          { value: '简体中文', abbr: 'zh-CN' }];
      }
   }
  var lanCur = language;
  if (language == 'USA') {
    lanCur = 'EN';
  }
  for (var i = 0; i < lanArr.length; i++) {
    if (lanArr[i].abbr == lanCur) {
      defaultIndex = i;
      break;
    }
  }
  var title = chooseLanguage[language];
  var okText = toolbarCloseText[language];
  var cancelText = submitCancelBtn[language];
  var $countryInput = $('#country-input');
  // 参数说明详见 picker.js
  $countryInput.picker({
    title: title,
    okText: okText,
    cancelText: cancelText,
    data: lanArr,
    name: 'value',
    value: 'value',
    selectedIndex: defaultIndex,
    pickerId: 'country-picker',
    onOk: function (selectedValue, selectedIndex) {
      for (var i = 0; i < lanArr.length; i++) {
        if (lanArr[i].value == selectedValue && lanCur != lanArr[i].abbr) {
          window.location.href = window.location.origin + window.location.pathname + '?locale=' + lanArr[i].abbr
          break;
        }
      }
    },
    onCancel: function () {
    }
  });


  //选择电话前缀
  var telArr = [];
  var defaultIndexTel = 0;
  var $submitInfoTelPre = $('#submitInfoTelPre');
  var telPreCurrent = $submitInfoTelPre.text().split('+')[1];
  var titleTel =chooseTelPre[language];
  for (var i = 0; i < globalTel.length; i++) {
    var value = globalTel[i].code + '-' + globalTel[i].countryAbbr;
    telArr.push({value:value});
    if(globalTel[i].code == telPreCurrent){
      defaultIndexTel = i;
    }
  }
  // 参数说明详见 picker.js
  $submitInfoTelPre.picker({
    title: titleTel,
    okText: okText,
    cancelText: cancelText,
    data: telArr,
    name: 'value',
    value: 'value',
    selectedIndex: defaultIndexTel,
    pickerId: 'submitInfoTelPre-picker',
    onOk: function (selectedValue, selectedIndex) {
       $("#submitInfoTelPre").text('+'+selectedValue.split('-')[0])
    },
    onCancel: function () {
    }
  });

  
});


// WEBPACK FOOTER //
// ./src/js/commons.js